import classNames from "classnames";
import React, { FunctionComponent, ReactElement } from "react";
import { FormattedNumber } from "react-intl";
import { ReactComponent as CheckCircle } from "@Icons/check-circle.svg";
import { ReactComponent as IconX } from "@Icons/cross.svg";
import { Price } from "@Types/api/price";
import "./style.scss";

interface Props {
  disabled: boolean;
  onDismiss: () => void;
  promoCode: string;
  promoTotal: Price;
}

const CartValidPromoCode: FunctionComponent<Props> = ({
  disabled,
  onDismiss,
  promoCode,
  promoTotal,
}): ReactElement => {
  return (
    <div
      className={classNames("CartValidPromoCode", {
        "CartValidPromoCode-disabled": disabled,
      })}
    >
      <div className="CartValidPromoCode-wrapper">
        <div className="CartValidPromoCode-promo">{promoCode}</div>
        <CheckCircle className="CartValidPromoCode-icons CartValidPromoCode-icons-check" />
      </div>
      <FormattedNumber
        currency={promoTotal.currency}
        style="currency"
        value={-promoTotal.cents / 100}
      />
      <IconX
        className="CartValidPromoCode-icons CartValidPromoCode-icons-removeLine"
        onClick={onDismiss}
      />
    </div>
  );
};

export default CartValidPromoCode;
